<template>
  <div :style="_style">
    <DatePickerComponent
      :format="format"
      :placeholder="placeholder"
      float-label-type="Always"
      :value="modelValue"
      :min="min"
      :max="max"
      @change="$emit('update:modelValue', $event.value)"
    />
  </div>
</template>

<script setup lang="ts">
import {DatePickerComponent} from '@syncfusion/ej2-vue-calendars';
import {computed} from "vue";

interface Props {
  placeholder?: string,
  modelValue?: Date,
  format?: string
  name?: string
  min?: Date
  max?: Date
  width?: string
}

const props = withDefaults(defineProps<Props>(), {
    modelValue: undefined,
    format: "dd.MM.yyyy",
    name: undefined,
    min: undefined,
    max: undefined,
    step: undefined,
    width: "160px",
    placeholder: undefined
  }
)
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const emit = defineEmits(['update:modelValue'])
//const input = ref<InstanceType<typeof DatePickerComponent> | null>(null)

const _style = computed<string>(() => props.width ? "width: " + props.width : "")

</script>

<style scoped>

</style>
